
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ussd",
      function () {
        return require("private-next-pages/ussd.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ussd"])
      });
    }
  